export const todayForPatch = () => {
 const now=new Date();
 return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
};
export const patchEarnedDate = (earnedOn,awardedAt) => new Date(earnedOn?`${earnedOn}T12:00:00`:awardedAt);
export const patchEarnedDateLabel = (earnedOn,awardedAt) => patchEarnedDate(earnedOn,awardedAt).toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric'});
